export var Status;
(function (Status) {
    /** Undefined reservation status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** A customer has begun the reservation flow, a temporary reservation is created and will expire in 10 minutes unless the customer moves forward with the reservation flow. This phase temporarily reserves the required number of seats and tables for a given party size at a chosen time while a customer enters details and/or confirms their reservation request. */
    Status["HELD"] = "HELD";
    /** The reservation is confirmed. */
    Status["RESERVED"] = "RESERVED";
    /** The reservation is canceled. */
    Status["CANCELED"] = "CANCELED";
    /** The reservation completed successfully. */
    Status["FINISHED"] = "FINISHED";
    /** The customer didn't show up for their reservation. */
    Status["NO_SHOW"] = "NO_SHOW";
    /** The customer is currently occupying the table. */
    Status["SEATED"] = "SEATED";
    /** A customer finished requesting this reservation, meaning they have added all necessary details and confirmed the request. Restaurant staff can now either approve or decline the reservation request. */
    Status["REQUESTED"] = "REQUESTED";
    /** The restaurant’s owner or staff declined the customer’s request to make the reservation. */
    Status["DECLINED"] = "DECLINED";
    Status["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    /** The reservation is awaiting payment. It will expire in 10 minutes from the created time unless the customer provides payment information. This phase temporarily reserves the required number of seats and tables for the given party size at the chosen time. */
    Status["PAYMENT_INFORMATION_PENDING"] = "PAYMENT_INFORMATION_PENDING";
})(Status || (Status = {}));
export var Source;
(function (Source) {
    /** Undefined reservation source. */
    Source["UNKNOWN"] = "UNKNOWN";
    /** The reservation was made by a restaurant employee, for example when a customer calls to make a reservation. */
    Source["OFFLINE"] = "OFFLINE";
    /** The reservation was made through a website or app. */
    Source["ONLINE"] = "ONLINE";
    /** The reservation was made by a restaurant employee when the customer arrived at the restaurant without a prior reservation. */
    Source["WALK_IN"] = "WALK_IN";
})(Source || (Source = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    /** Undefined payment status. */
    PaymentStatus["UNKNOWN"] = "UNKNOWN";
    /** A reservation is free of charge. */
    PaymentStatus["FREE"] = "FREE";
    /** Payment is not received yet. */
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** The corresponding reservation order was fully paid. */
    PaymentStatus["PAID"] = "PAID";
    /** The corresponding reservation order was refunded, but the refund amount is less than the order total price. */
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    /** The corresponding reservation order was fully refunded. The refund amount equals the total price. */
    PaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    /** The corresponding reservation order was partially paid. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(PaymentStatus || (PaymentStatus = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    /** Undefined conflict type. */
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    /** One or more of the chosen tables are already reserved. */
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    /** The party is too big for the selected table. */
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    /** The party is too small for the selected table. */
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    /** The restaurant does not allow online reservations. */
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    /** Undefined reservation location conflict type. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** The restaurant cannot accommodate a party of the given size according to party pacing settings. */
    Type["PARTY_PACING"] = "PARTY_PACING";
    /** The required number of seats are unavailable according to seat pacing settings. */
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
export var ExperienceTableCombinationConflictType;
(function (ExperienceTableCombinationConflictType) {
    /** Undefined conflict type. */
    ExperienceTableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    /** One or more of the chosen tables are already reserved. */
    ExperienceTableCombinationConflictType["RESERVED"] = "RESERVED";
    /** The party is too big for the selected table. */
    ExperienceTableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    /** The party is too small for the selected table. */
    ExperienceTableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
})(ExperienceTableCombinationConflictType || (ExperienceTableCombinationConflictType = {}));
export var ExperienceConflictType;
(function (ExperienceConflictType) {
    /** Undefined reservation location conflict type. */
    ExperienceConflictType["UNKNOWN"] = "UNKNOWN";
    /** The number of guests exceeds the allowed limit. */
    ExperienceConflictType["MAXIMUM_NUMBER_OF_GUESTS"] = "MAXIMUM_NUMBER_OF_GUESTS";
})(ExperienceConflictType || (ExperienceConflictType = {}));
export var IgnoreConflictsType;
(function (IgnoreConflictsType) {
    IgnoreConflictsType["UNKNOWN_IGNORE_CONFLICTS_TYPE"] = "UNKNOWN_IGNORE_CONFLICTS_TYPE";
    IgnoreConflictsType["STANDARD"] = "STANDARD";
    IgnoreConflictsType["EXPERIENCE"] = "EXPERIENCE";
})(IgnoreConflictsType || (IgnoreConflictsType = {}));
export var ConflictsType;
(function (ConflictsType) {
    ConflictsType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ConflictsType["STANDARD"] = "STANDARD";
    ConflictsType["EXPERIENCE"] = "EXPERIENCE";
})(ConflictsType || (ConflictsType = {}));
export var Set;
(function (Set) {
    /** Returns `id`, `status`, `details.reservationLocationId`, `details.experienceId`, `details.startDate`, `details.endDate`, `details.partySize`, `createdDate`, `revision`, `declineReason`, `paymentStatus`. */
    Set["PUBLIC"] = "PUBLIC";
    /** Returns all fields. */
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var SortOrder;
(function (SortOrder) {
    /** Sort by ascending order. */
    SortOrder["ASC"] = "ASC";
    /** Sort by descending order. */
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Sort by number of matches. */
    SortType["COUNT"] = "COUNT";
    /** Sort by value of the field alphabetically. */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Sort in descending order. */
    SortDirection["DESC"] = "DESC";
    /** Sort in ascending order. */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Exclude missing values from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Include missing values in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    /** Undefined scalar type. */
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values. */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value. */
    ScalarType["MIN"] = "MIN";
    /** Maximum value. */
    ScalarType["MAX"] = "MAX";
    /** Sum of values. */
    ScalarType["SUM"] = "SUM";
    /** Average of values. */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    /** Undefined aggregation type. */
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value. */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation where you can define a set of ranges - each representing a bucket. */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - such as min, max, sum, and avg. */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation where result buckets are dynamically built - one per time interval such as hour, day, or week. */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    Interval["YEAR"] = "YEAR";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["DAY"] = "DAY";
    Interval["HOUR"] = "HOUR";
    Interval["MINUTE"] = "MINUTE";
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    /** Undefined aggregation type. */
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value. */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation where you can define a set of ranges - each representing a bucket. */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - such as min, max, sum, or avg. */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation where result buckets are dynamically built - one per time interval such as hour, day, or week. */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within the previous one. */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Returns instances where any terms in the expression occur. */
    Mode["OR"] = "OR";
    /** Returns instances where all the terms in the expression occur. */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map